/**
 * [#736 W31-S04] Composer-side message ceiling, mirrored server-side as
 * MAX_STREAM_MESSAGE_CHARS in backend/src/routes/stevens-v4.js — keep the two
 * in sync. Far above any legitimate coaching message; exists so an over-limit
 * paste gets a clear, actionable message instead of an opaque failure.
 *
 * Lives in its own module (rather than in stevensV4Service.ts) so composers
 * can import it without pulling in — or being coupled to test mocks of — the
 * transport service.
 */
export const MAX_CHAT_MESSAGE_LENGTH = 50000;
